import React from "react";
import { IconProps } from "../index";
import { colors } from "src/assets";

const Index: React.FC<IconProps> = ({ color, size }) => {
  const localWidth = size * (16.121 / 14);
  const localHeight = size * (16.121 / 14);
  const localColor = color || colors.white;
  return (
    <svg width={localWidth} height={localHeight} viewBox="0 0 16.121 16.121">
      <g transform="translate(-334.939 -126.939)">
        <path
          d="M1557,1252l14,14"
          transform="translate(-1221 -1124)"
          fill="none"
          stroke={localColor}
          strokeLinecap="round"
          strokeWidth="1.5"
        />
        <path
          d="M1571,1252l-14,14"
          transform="translate(-1221 -1124)"
          fill="none"
          stroke={localColor}
          strokeLinecap="round"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  );
};

export default Index;
